import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import { getNearbyFacilities } from 'store/selectors/getNearbyFacilities';
import {
	getLocalPhoneNumberByZipCode,
	getLocalPhoneNumberByCityState,
} from 'store/pageMeta/slice';
import {
	Container,
	Section,
	Row,
	Column,
	H2,
	Link,
	Paragraph,
} from 'components/atoms';
import { SFIcon } from 'components/core/SFIcon';
import { ScrollWrapper } from 'components/molecules';
import { FacilityCard } from 'components/search/FacilityCard';

import './PLPFacilitiesSection.scss';

export function PLPFacilitiesSection({ title, headerLinkText, headerLink }) {
	const nearbyFacilities = useSelector((state) => getNearbyFacilities(state));
	const dispatch = useDispatch();

	const handleGetLocalPhoneNumberByZipCode = useCallback(
		(...args) => dispatch(getLocalPhoneNumberByZipCode(...args)),
		[dispatch],
	);

	const handleGetLocalPhoneNumberByCityState = useCallback(
		(...args) => dispatch(getLocalPhoneNumberByCityState(...args)),
		[dispatch],
	);

	if (!nearbyFacilities) {
		return null;
	}
	const location = nearbyFacilities?.location;
	const facilities =
		nearbyFacilities?.facilityCollection.collection || [];
	return (
		<Section
			className={'facilities-section'}
			id="facilities-nearby"
		>
			<Container>
				<Row>
					<Column md={12}>
						<div className="plp-section-title">
							<H2
								weight="ultraBold"
								color="black"
								className="plp-section-title-header"
							>
								{title} {location.text}
							</H2>
							{/* The 'Compare' Button below needs to be updated in  */}
							{/* a newer version of this. Right now it uses the 'old' */}
							{/* geoDetection - not the new cloudflare location headers */}
							{headerLink && (
								<Paragraph>
									<Link
										href={headerLink}
										link
										className="plp-section-title-link"
									>
										{headerLinkText}
									</Link>
									<SFIcon icon="chevron-right" />
								</Paragraph>
							)}
						</div>
					</Column>
				</Row>
			</Container>
			<Container className="plp-facility-card-container">
				<ScrollWrapper
					className={'plp-facility-card-arrangement'}
					slug={'nearby-facilities'}
					fullSpace
				>
					{facilities?.map((facility, index) => (
						<FacilityCard
							key={facility.id}
							searchLocation={location}
							facility={facility}
							phone={'112asd3'}
							className="scroll-card nearby-facility-card"
							page="paid"
							position={index + 1}
							lazyLoad={true}
							getLocalPhoneNumberByCityState={
								handleGetLocalPhoneNumberByCityState
							}
							getLocalPhoneNumberByZipCode={
								handleGetLocalPhoneNumberByZipCode
							}
							withSchema
						/>
					))}
				</ScrollWrapper>
			</Container>
		</Section>
	);
}

PLPFacilitiesSection.propTypes = {
	nearbyFacilities: PropTypes.object,
	getLocalPhoneNumberByCityState: PropTypes.func,
	getLocalPhoneNumberByZipCode: PropTypes.func,
	title: PropTypes.string,
	headerLinkText: PropTypes.string,
	headerLink: PropTypes.string,
};

export default PLPFacilitiesSection;
